var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRoMachineHover(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 135.001,
    height: 112.003,
    viewBox: "0 0 135.001 112.003",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_28594",
    "data-name": "Group 28594",
    transform: "translate(-572.011 -528.501)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_13173",
    "data-name": "Rectangle 13173",
    width: 135,
    height: 112,
    rx: 10,
    transform: "translate(572.011 528.501)",
    fill: "#00aec7"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_28036",
    "data-name": "Group 28036",
    transform: "translate(19.011 -112.498)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_17",
    "data-name": "Subtraction 17",
    d: "M15685.553,1241.5h-57.85a10.012,10.012,0,0,1-10-10v-92a10.012,10.012,0,0,1,10-10h115a10.014,10.014,0,0,1,10,10v36.8l-31.963-28.931-74.662,74.488,39.472,19.639Z",
    transform: "translate(-15064.705 -488.5)",
    fill: "#00aec7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_13175",
    "data-name": "Rectangle 13175",
    transform: "translate(599.012 546.501)",
    fill: "#00aec7",
    stroke: "#fff",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("rect", {
    width: 76,
    height: 76,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 73,
    height: 73,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_28595",
    "data-name": "Group 28595",
    transform: "translate(315.011 284.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_28587",
    "data-name": "Group 28587",
    transform: "translate(298 301.823)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_13761",
    "data-name": "Rectangle 13761",
    width: 11.66,
    height: 19.433,
    transform: "translate(0 5.441)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_246",
    "data-name": "Ellipse 246",
    cx: 5.83,
    cy: 5.83,
    r: 5.83,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_247",
    "data-name": "Ellipse 247",
    cx: 5.83,
    cy: 5.83,
    r: 5.83,
    transform: "translate(0 18.656)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_28588",
    "data-name": "Group 28588",
    transform: "translate(315.879 301.823)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_13761-2",
    "data-name": "Rectangle 13761",
    width: 11.66,
    height: 19.433,
    transform: "translate(0 5.441)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_246-2",
    "data-name": "Ellipse 246",
    cx: 5.83,
    cy: 5.83,
    r: 5.83,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_247-2",
    "data-name": "Ellipse 247",
    cx: 5.83,
    cy: 5.83,
    r: 5.83,
    transform: "translate(0 18.656)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_28589",
    "data-name": "Group 28589",
    transform: "translate(333.758 301.824)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_190",
    "data-name": "Union 190",
    d: "M.012,24.873H0V5.439H.012a5.831,5.831,0,0,1,11.635,0h.013V24.873h-.013a5.83,5.83,0,0,1-11.635,0Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_34107",
    "data-name": "Path 34107",
    d: "M-15296-421.5h24.222",
    transform: "translate(15605.66 740.972)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34108",
    "data-name": "Path 34108",
    d: "M-15296-421.5h24.222",
    transform: "translate(15605.66 733.976)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_251",
    "data-name": "Ellipse 251",
    transform: "translate(301.109 289.545)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3.498,
    cy: 3.498,
    r: 3.498,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.498,
    cy: 3.498,
    r: 2.498,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_252",
    "data-name": "Ellipse 252",
    transform: "translate(301.109 279.828)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3.498,
    cy: 3.498,
    r: 3.498,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.498,
    cy: 3.498,
    r: 2.498,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_253",
    "data-name": "Ellipse 253",
    transform: "translate(301.109 270.5)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3.498,
    cy: 3.498,
    r: 3.498,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.498,
    cy: 3.498,
    r: 2.498,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_28591",
    "data-name": "Group 28591",
    transform: "translate(309.66 292.654)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_248",
    "data-name": "Ellipse 248",
    cx: 3.498,
    cy: 3.498,
    r: 3.498,
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_13762",
    "data-name": "Rectangle 13762",
    width: 31.871,
    height: 6.996,
    transform: "translate(3.887 0)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_28590",
    "data-name": "Group 28590",
    transform: "translate(309.66 283.326)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_249",
    "data-name": "Ellipse 249",
    cx: 3.498,
    cy: 3.498,
    r: 3.498,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_13763",
    "data-name": "Rectangle 13763",
    width: 31.871,
    height: 6.996,
    transform: "translate(3.887)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_28592",
    "data-name": "Group 28592",
    transform: "translate(309.66 273.998)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_250",
    "data-name": "Ellipse 250",
    cx: 3.498,
    cy: 3.498,
    r: 3.498,
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_13764",
    "data-name": "Rectangle 13764",
    width: 31.871,
    height: 6.996,
    transform: "translate(3.887 0)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoMachineHover);
export default __webpack_public_path__ + "static/media/roMachineHover.80700ce267f633c5b73f9ace87368ad7.svg";
export { ForwardRef as ReactComponent };